<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
       <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Products</a>
        </li>
      </ol>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row mt-2">
      <div class="col-lg-12">
        <div>
          <button  class="btn btn-default" (click)="addProductModal.show()">Add New Product</button>
          <br/>
          <br/>
          <ng-template #blankTemplate>
          </ng-template>

          <table class="table table-striped">
            <thead>
                <tr>
                    <th>Product ID</th>
                    <th>Product Name</th> 
                    <th>Description</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody *ngIf ="service.data">
                <tr class="gradeX" *ngFor=" let product of service.remoteData | async; let i = index;">
                    <td>{{ product.productId }}</td>
                    <td>{{ product.productName }}</td>
                    <td>{{ product.description }}</td>
                    <td>
                      <button class="btn btn-xs btn-primary" (click)="selectProduct(product)" [attr.checked]="product?.productId == editProduct?.productId">Select</button>   
                      <button class="btn btn-xs btn-primary ml-2" (click)="editProduct=product;editProductModal.show()"><i class="fa fa-pencil"></i></button>              
                      <button class="btn btn-xs btn-danger ml-2" (click)="removeProduct(product)"><i class="fa fa-trash"></i></button>                                         
                    </td>
                </tr> 
            </tbody>
            <tbody *ngIf ="service.data == null || service.data.length == 0">
                <tr  class="gradeX">
                    
                    <!-- todo - Appears as if the order return from the new services doesn't include the commented out keys from below -->
                    <td colspan="4">No Products</td>  
                </tr>
            </tbody>
        </table>
        <br/>
        <br/>
        <br/><button *ngIf="editProduct" class="btn btn-default" (click)="addLicenseType.show()">Add New License Type</button>
        <br/>
        <br/>
        <table class="table table-striped" *ngIf="editProduct">
          <thead>
              <tr>
                  <th>License Type ID</th>
                  <th>Product Name</th> 
                  <th>Description</th>
                  <th>Action</th>
              </tr>
          </thead>
          <tbody *ngIf ="editProduct && editProduct.licenseTypes && editProduct.licenseTypes.length > 0">
              <tr class="gradeX" *ngFor=" let licenseType of editProduct.licenseTypes; let i = index;">
                  <td>{{ licenseType.licenseTypeId }}</td>
                  <td>{{ licenseType.licenseName }}</td>
                  <td>{{ licenseType.description }}</td>
                  <td>
                    <button class="btn btn-xs btn-primary" (click)="editLicense=licenseType;editLicenseTypeModal.show()"><i class="fa fa-pencil"></i></button>              
                    <button class="btn btn-xs btn-danger ml-2" (click)="removeLicense(licenseType)"><i class="fa fa-trash"></i></button>                      
                  </td>
              </tr>
          </tbody>
          <tbody *ngIf ="editProduct == null || editProduct.licenseTypes == null || editProduct.licenseTypes.length == 0">
              <tr  class="gradeX">
                  
                  <!-- todo - Appears as if the order return from the new services doesn't include the commented out keys from below -->
                  <td colspan="4">No License Types</td>  
              </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

  <div class="modal fade" bsModal #addProductModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg" >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Product</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addProductModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Product Name</label>
                <div class="input-group m-b">
                    <input id="serverToken" type="text" class="form-control" [(ngModel)]="product.productName" />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Product Description</label>
                <div class="input-group m-b">
                    <input id="serverToken" type="text" class="form-control" [(ngModel)]="product.description" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="addProductModal.hide()" class="btn btn-white">Cancel</button>
          <button (click)="addRow();addProductModal.hide()" class="btn btn-white">Add</button>
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal fade" bsModal #editProductModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg" >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Product</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="editProductModal.hide()"></button>
        </div>
        <div class="modal-body" *ngIf="editProduct">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Product Name</label>
                <div class="input-group m-b">
                    <input id="serverToken" type="text" class="form-control" [(ngModel)]="editProduct.productName" />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Product Description</label>
                <div class="input-group m-b">
                    <input id="serverToken" type="text" class="form-control" [(ngModel)]="editProduct.description" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="editProductModal.hide()" class="btn btn-white">Cancel</button>
          <button (click)="saveRow(editProduct);editProductModal.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" bsModal #addLicenseType="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg" >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add License Type</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addLicenseType.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>License Name</label>
                <div class="input-group m-b">
                    <input id="serverToken" type="text" class="form-control" [(ngModel)]="license.licenseName" />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>License Description</label>
                <div class="input-group m-b">
                    <input id="serverToken" type="text" class="form-control" [(ngModel)]="license.description" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="license = {}; addLicenseType.hide()" class="btn btn-white">Cancel</button>
          <button (click)="addLicense();addLicenseType.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" bsModal #editLicenseTypeModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg" >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit License Type</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="editLicenseTypeModal.hide()"></button>
        </div>
        <div class="modal-body" *ngIf="editLicense">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>License Name</label>
                <div class="input-group m-b">
                    <input id="serverToken" type="text" class="form-control" [(ngModel)]="editLicense.licenseName" />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>License Description</label>
                <div class="input-group m-b">
                    <input id="serverToken" type="text" class="form-control" [(ngModel)]="editLicense.description" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="editLicense = {}; editLicenseTypeModal.hide()" class="btn btn-white">Cancel</button>
          <button (click)="saveLicenseType(editLicense);editLicenseTypeModal.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
  </div>